import React from 'react'
// components
import OverviewComponent from './overview/overview'
import SettingsComponent from './settings/settings'
import LoadingImage from '../../images/subSyncIcons/SubSync_100x100.gif'

// definitions
import * as AppDefinitions from '../../App.d'
import { OrgSettings, HistoryView, InvoiceRetryBody, EventRetryBody } from '../../screens/subsync/subsync'
import { BillingComponent } from './billing/billing'

type FrameType = 'overview' | 'billing' | string // where string = 'settings_{id}'

interface FrameProps {
	pageStatus: string
	appState: AppDefinitions.AppState
	currentFrame: FrameType
	historyView: HistoryView
	updateHistoryView: (historyView: HistoryView) => void
	orgSettings: OrgSettings
	updateOrgSettings: (orgSettings: OrgSettings) => void
	refreshSettingsData: () => void
	refreshInvoiceData: () => void
	refreshPayoutData: () => void
	refreshPaymentData: () => void
	retryFailedInvoiceTransaction: (body: InvoiceRetryBody) => void
	retryFailedEvent: (body: EventRetryBody) => void
}

const BodyFrame = (props: FrameProps) => {
	if (props.pageStatus === 'Finished') {
		return (
			<>
				<OverviewComponent
					show={props.currentFrame === 'overview'}
					appState={props.appState}
					stripeFeesBillsEnabled={props.orgSettings.orgMappings.some((mapping) => mapping.stripeOrgAccountXeroOrgSettings?.stripeFeesBillsEnabled)}
					creditNotesEnabled={props.orgSettings.orgMappings.some((mapping) => mapping.stripeOrgAccountXeroOrgSettings?.creditNotesEnabled)}
					historyView={props.historyView}
					updateHistoryView={props.updateHistoryView}
					refreshInvoiceData={props.refreshInvoiceData}
					refreshPayoutData={props.refreshPayoutData}
					refreshPaymentData={props.refreshPaymentData}
					retryFailedInvoiceTransaction={props.retryFailedInvoiceTransaction}
					retryFailedEvent={props.retryFailedEvent}
				/>
				<SettingsComponent
					show={props.currentFrame.includes('settings')}
					appState={props.appState}
					orgSettings={props.orgSettings}
					updateOrgSettings={props.updateOrgSettings}
					refreshData={props.refreshSettingsData}
				/>
				{props.orgSettings.xeroOrgs.length > 0 && (
					<BillingComponent show={props.currentFrame === 'billing'} appState={props.appState} orgSettings={props.orgSettings} />
				)}
			</>
		)
	} else {
		return (
			<div className="loading-gif">
				<img src={LoadingImage} alt="Loading ..." />
			</div>
		)
	}
}

export type { FrameType }
export default BodyFrame
